// extracted by mini-css-extract-plugin
module.exports = {"container":"_videos_container__MEVwW","layout":"_videos_layout__hjPDT"};